import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import orgIcon from '../assets/org.svg';
import { API } from '../utils/amplifyWrapper';
import { Auth } from '../utils/amplifyWrapper';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Spinner from '../components/Spinner';
import * as Sentry from '@sentry/react';
import { fetchIpInfoService } from '../utils/Country'
import { goToCurrentIntegration, goToUpgradePage } from '../utils/General';
import { Card } from '../components/ui/bootstrap';
import { ArrowRight } from 'lucide-react';
import BootLoadingScreen from '../components/BootLoadingScreen';
const classNames = require('classnames');

function Organisation() {

    const history = useHistory();
    const { search } = useLocation();
    const queryString = new URLSearchParams(search)
    const plan_id = queryString.get("plan_id")

    const [organisations, setOrganisations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [userAttr, setUserAttr] = useState(null);
    const [show, setShow] = useState(false);
    const [showOrgCreationModal, setShowOrgCreationModal] = useState(false);
    const [isCreatingOrg, setIsCreatingOrg] = useState(false);
    const [orgName, setOrgName] = useState("");
    const [orgNameError, setOrgNameError] = useState(null);

    const onNewOrganisation = () => {

        setShow(true);

    }

    const onCreateOrganisation = async () => {

        if (orgName.length === 0) {
            setOrgNameError("Name is required");
            return;
        }

        setIsCreatingOrg(true);

        const userLocationData = await fetchIpInfoService()

        const location = {
            country: userLocationData.country,
        }

        API.post(`main`, `/organisation`, { body: { name: orgName, location }, headers: { "Content-Type": "application/json" } })
            .then((response) => {

                toast.success("Organisation has been created");
                history.push(`/organisation/${response.data.id}/plans`);

            }).catch((error) => {

                toast.error("Something went wrong wile creating the organisation.");
                Sentry.captureException(error);

            }).finally(() => {

                setIsCreatingOrg(false);

            });

    }

    const cardStyle = {
        width: 256,
        minHeight: 160,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
    };

    const Organisations = () => (
        <React.Fragment>
            <div className="row my-5">
                <div className="col-12">
                    <h3>Welcome {(userAttr && userAttr.hasOwnProperty("given_name") ? userAttr.given_name : ' to Listen2It')}!</h3>
                    <p>Please choose an Organisation</p>
                </div>
            </div>
            <div className="d-flex flex-wrap gap-3 mb-5">
                {organisations.map((org) => (
                    <Card
                        key={`org-card-${org.PK.split('#')[1]}`}
                        className="p-4"
                        style={cardStyle}
                        shadow
                    >
                        <div className="flex-grow-1 d-flex align-items-center gap-2">
                            <img src={orgIcon} alt="org icon" />
                            <span className="fw-semibold text-body-emphasis text-truncate">{org.org_name}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <button
                                type="button"
                                className="btn btn-sm d-inline-flex align-items-center gap-1"
                                style={{
                                    background: 'rgba(var(--bs-primary-rgb),0.08)',
                                    border: '1px solid rgba(var(--bs-primary-rgb),0.2)',
                                    color: 'var(--bs-primary)',
                                    borderRadius: 50,
                                    fontSize: 13,
                                    padding: '4px 14px',
                                }}
                                onClick={() => history.push(`/organisation/${org.PK.split('#')[1]}/integration`)}
                            >
                                Projects <ArrowRight size={13} />
                            </button>
                        </div>
                    </Card>
                ))}
                <Card
                    className="p-4 d-flex flex-column align-items-center justify-content-center"
                    style={{ ...cardStyle, cursor: 'pointer' }}
                    onClick={onNewOrganisation}
                >
                    <svg fill="none" stroke="var(--bs-secondary-color)" height={48} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="fw-semibold text-body-emphasis mb-0 mt-2">New Organisation</p>
                </Card>
            </div>
        </React.Fragment>
    );

    const EmptyState = () => (
        <div className="col-md-6 py-5">
            <p className="fw-bold text-body-emphasis mb-4" style={{ fontSize: 22 }}>Welcome {(userAttr && userAttr.hasOwnProperty("name") ? userAttr.name : ' to Listen2It')}!</p>
            <p className="text-secondary">Get started by creating your first organisation.</p>
            <p className="text-secondary">For more information, we recommend going through our Getting Started Guide.</p>
            <button type="button" className="btn btn-primary" onClick={() => setShowOrgCreationModal(true)}>Create an Organisation</button>
        </div>
    );

    useEffect(() => {

        Auth.currentAuthenticatedUser({
            bypassCache: true
        }).then(user => { setUserAttr(user.attributes); })
            .catch(err => Sentry.captureException(err));

        if (plan_id) {
            goToUpgradePage(history, plan_id)
        } else {
            goToCurrentIntegration(history)
        }

    }, []);

    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className="container">
                    {
                        (isLoading) ?
                            (
                                <BootLoadingScreen />
                            )
                            :
                            (
                                (organisations.length > 0)
                                    ?
                                    (
                                        <Organisations />
                                    )
                                    :
                                    (
                                        <EmptyState />
                                    )
                            )
                    }
                </div>
                <Modal show={show} onHide={() => { setShow(false) }}>
                    <Modal.Body>
                        <div className="text-center">
                            <p><strong>The free and full plan supports only one organisation.</strong></p>
                            <p>Upgrade to enterprise plan to unlock unlimited organisations.</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-primary me-3" onClick={() => setShow(false)}>Cancel</button>
                        <a href="https://www.getlisten2it.com/contact" target="_blank" rel="noopener noreferrer">
                            <button type="button" className="btn btn-primary">Contact Us</button>
                        </a>
                    </Modal.Footer>
                </Modal>
                <Modal show={showOrgCreationModal} onHide={() => { setShowOrgCreationModal(false) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Create an Organisation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="mb-3">
                                <label>Give it a name</label>
                                <input type="text" className={classNames("form-control", { "is-invalid": orgNameError })} onChange={(event) => { setOrgNameError(null); setOrgName(event.target.value) }} />
                                {
                                    (orgNameError) &&
                                    <div className="invalid-feedback">
                                        {orgNameError}
                                    </div>
                                }
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-primary me-3" onClick={() => setShowOrgCreationModal(false)}>Cancel</button>
                        {
                            (isCreatingOrg) ?
                                (
                                    <button type="button" className="btn btn-primary text-center">
                                        <Spinner color="white" />
                                    </button>
                                )
                                :
                                (
                                    <button type="button" className="btn btn-primary" onClick={onCreateOrganisation}>Save</button>
                                )
                        }
                    </Modal.Footer>
                </Modal>
            </div>
        </React.Fragment>
    );

}


export default Organisation;
